import Parse from 'parse'
import { createUserData } from '@/helpers/utils'

export default {
  async login ({ commit, dispatch }, { email, password }) {
    console.log('User.login: ' + email)
    const user = await Parse.User.logIn(email, password)
    commit('setUILanguage', user.get('language'))
    return dispatch('fetchUserData')
  },

  async logout ({ commit }) {
    console.log('User.logout')
    await Parse.User.logOut()
    // TODO: set UI language to system language
    commit('clearUser')
  },

  async become ({ commit, dispatch }, { sessionToken }) {
    console.log('User.become: ' + sessionToken)
    const user = await Parse.User.become(sessionToken)
    commit('setUILanguage', user.get('language'))
    return dispatch('fetchUserData')
  },

  async resetPassword (context, { email }) {
    return Parse.User.requestPasswordReset(email)
  },

  /**
  * Needs to be called after logging in (to fetch the user's address data) and
  * after changing user data (because the local Parse user object
  * (Parse.User.current) is not updated when calling the API function
  * CC.updateUser)
  * TODO: should be a private function
  * TODO: should also fetch unaccepted options, e.g. ToS and invitations
  */
  async fetchUserData ({ commit, getters }) {
    const parseUser = Parse.User.current()
    if (!parseUser) {
      return
    }

    const parseAddress = parseUser.get('address')
    const [ user, address ] = await Promise.all([
      parseUser.fetch(),
      parseAddress ? parseAddress.fetch() : null
    ])

    commit('setCurrentUserId', user.id)
    commit('setUserData', createUserData(user, address))
  },

  async saveUserData ({ dispatch, state }) {
    const { firstName, lastName, language } = state.userData

    const params = {
      userId: state.currentUserId,
      user: { firstName, lastName, language },
      address: {} // TODO: remove when CC.updateUser supports calls without address data
    }

    await Parse.Cloud.run('updateUser', params)

    // update cached user data
    // TODO: shouldn't this happen automatically because the CC func returns
    // the updated user, especially since Parse.Object.enableSingleInstance
    // is active?
    return dispatch('fetchUserData')

    // TODO: should the 'saved' state be stored in the vuex store?
    // e.g. by storing savedUserData in addition to userData, and a computed
    // prop isDirty which compares the two objects
  },

  async fetchBlackBoard ({ commit }) {
    const blackboard = await Parse.Cloud.run('fetchBlackBoard')
    commit('setBlackBoard', blackboard)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js